(function () {
  var pollingActive = false;

  function getCart() {
    return fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart request failed: ' + response.status);
      }

      return response.json();
    });
  }

  function getCartSignature(cart) {
    return JSON.stringify(
      cart.items.map(function (item) {
        return {
          key: item.key,
          quantity: item.quantity
        };
      })
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      var bundleButton = event.target.closest(
        '.bogos-bp-button-add, .bogos-bundle-pp-btn-add'
      );

      if (!bundleButton || pollingActive) {
        return;
      }

      pollingActive = true;

      getCart()
        .then(function (originalCart) {
          var originalSignature =
            getCartSignature(originalCart);

          var attempts = 0;
          var interval = window.setInterval(function () {
            attempts += 1;

            getCart()
              .then(function (updatedCart) {
                var updatedSignature =
                  getCartSignature(updatedCart);

                if (updatedSignature !== originalSignature) {
                  window.clearInterval(interval);
                  pollingActive = false;

                  document.dispatchEvent(
                    new CustomEvent('ajaxProduct:added', {
                      detail: {
                        product: updatedCart.items[0] || {},
                        addToCartBtn: bundleButton,
                        cart: updatedCart,
                        source: 'bogos'
                      }
                    })
                  );

                  return;
                }

                if (attempts >= 40) {
                  window.clearInterval(interval);
                  pollingActive = false;
                }
              })
              .catch(function () {
                if (attempts >= 40) {
                  window.clearInterval(interval);
                  pollingActive = false;
                }
              });
          }, 250);
        })
        .catch(function () {
          pollingActive = false;
        });
    },
    true
  );
})();